import { createContext, useContext, useMemo, useState } from 'react'

import type { IWebGlRender, Nullable, Property } from '../../types'

type WebGlContextType = {
  canvas: Property<Nullable<HTMLCanvasElement>>
  renderQueue: Property<IWebGlRender[]>
  update: Property<number>
  programs: Property<Record<string, WebGLProgram>>
  textures: Property<Record<string, WebGLTexture>>
}

const stubFunction = () => {
  console.warn('Была вызвана заглушка, возможно, что-то пошло не так')
}

const initialContext: WebGlContextType = {
  canvas: { value: null, setValue: stubFunction },
  renderQueue: { value: [], setValue: stubFunction },
  update: { value: 0, setValue: stubFunction },
  programs: { value: {}, setValue: stubFunction },
  textures: { value: {}, setValue: stubFunction },
}

export const WebGlContext = createContext<WebGlContextType>(initialContext)

export const useWebGlConstructContext = () => {
  const [canvas, setCanvas] = useState<Nullable<HTMLCanvasElement>>(null)
  const [renders, setRenders] = useState<IWebGlRender[]>([])
  const [update, setUpdate] = useState<number>(0)
  const [programs, setPrograms] = useState<Record<string, WebGLProgram>>({})
  const [textures, setTextures] = useState<Record<string, WebGLTexture>>({})
  const value = useMemo<WebGlContextType>(
    () => ({
      canvas: {
        value: canvas,
        setValue: setCanvas,
      },
      renderQueue: {
        value: renders,
        setValue: setRenders,
      },
      update: {
        value: update,
        setValue: setUpdate,
      },
      programs: {
        value: programs,
        setValue: setPrograms,
      },
      textures: {
        value: textures,
        setValue: setTextures,
      },
    }),
    [canvas, renders, update, programs, textures],
  )

  return value
}

export const useWebGlContext = () => useContext(WebGlContext)
